import React from "react";
import parse, { domToReact } from "html-react-parser";
import PullQuote from "components/article/pullQuote";
import { Box, Flex, Heading, TextLink } from "@indeed/ifl-components";
import { Ellipse } from "components/article/ellipse";

const headings = ["h2", "h3", "h4", "h5", "h6"];
const levels = [
  {
    fontSize: ["24px", null, null, "30px"],
    fontWeight: [300, null, null, 400],
    lineHeight: [1.15, null, null, 1.25],
    fontFamily: "Indeed Sans",
    mb: "34px",
    mt: "40px",
  },
  {
    fontSize: ["20px", null, null, "24px"],
    fontWeight: 700,
    lineHeight: 1.25,
    fontFamily: "Indeed Sans",
    mb: "34px",
    mt: "40px",
  },
  {
    fontSize: "18px",
    fontWeight: 700,
    lineHeight: "normal",
    fontFamily: "Indeed Sans",
  },
  {
    fontSize: "16px",
    fontWeight: 700,
    lineHeight: "normal",
    fontFamily: "Indeed Sans",
  },
  {
    fontFamily: "Indeed Sans",
  },
];

const renderComponents = (domNode, { maxWidth, contentWidth }) => {
  if (domNode.name === "iframe") {
    return (
      <Box
        as="span"
        sx={{
          display: "block",
          position: "relative",
          pb: "56.25%",
          pt: "30px",
          height: 0,
          overflow: "hidden",
        }}
      >
        <Box
          as={domNode.name}
          {...domNode.attribs}
          frameBorder="0"
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
          }}
        >
          {domToReact(domNode.children)}
        </Box>
      </Box>
    );
  }

  if (domNode.name === "img") {
    const {
      height,
      width,
      srcset: srcSet = "",
      class: className = "",
      ...rest
    } = domNode.attribs;
    return (
      <Box
        as="img"
        width="100%"
        height="100%"
        srcSet={srcSet}
        className={className}
        {...rest}
      />
    );
  }
  if (domNode.name === "blockquote") {
    return (
      <PullQuote maxW={maxWidth} contentW={contentWidth}>
        {domToReact(domNode.children)}
      </PullQuote>
    );
  }
  if (domNode.name === "indeed-pull-quote") {
    const quote = domNode.attribs && domNode.attribs.quote;
    const author = domNode.attribs && domNode.attribs.author;
    return (
      <indeed-pull-quote width={contentWidth} quote={quote} author={author} />
    );
  }
  if (domNode.name === "indeed-block-quote") {
    const quote = domNode.attribs && domNode.attribs.quote;
    return <indeed-block-quote quote={quote} />;
  }
  if (
    domNode.name === "div" &&
    domNode.attribs &&
    domNode.attribs.class &&
    domNode.attribs.class === "interpunct"
  ) {
    return (
      <Flex
        sx={{
          width: "100%",
          justifyContent: "center",
          my: 8,
          svg: {
            mx: 2,
          },
        }}
      >
        <Ellipse />
        <Ellipse />
        <Ellipse />
      </Flex>
    );
  }
  if (headings.includes(domNode.name)) {
    const fontLevel = headings.indexOf(domNode.name);
    const { ...rest } = levels[fontLevel];
    return (
      <Heading as={domNode.name} sx={{ ...rest }}>
        {domToReact(domNode.children)}
      </Heading>
    );
  }

  if (domNode.name === "figure") {
    domNode.attribs.style = "";
    domNode.attribs.style =
      "display:flex; flex-direction:column; align-items:center;";
    return domNode;
  }

  if (domNode.name === "a") {
    return (
      <TextLink
        href={domNode.attribs.href}
        target="_blank"
        sx={{ display: "inline" }}
      >
        {domToReact(domNode.children)}
      </TextLink>
    );
  }
};

export const contentParser = (content, opts) => {
  return content
    ? parse(content, {
        replace: (domNode) => renderComponents(domNode, opts),
      })
    : "";
};
